import { memo } from 'react';

import CopyIconSVG from '@/assets/copy-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICopyIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CopyIconSVG} {...props} />;

export const CopyIcon = memo(ICopyIcon) as typeof ICopyIcon;
